/** Synthetic headers only — not a real mailbox dump. */
export const SAMPLE_HEADERS = [
	'Delivered-To: victim@example.invalid',
	'Return-Path: <bounce@mail.phish-example.invalid>',
	'Received: from mail.phish-example.invalid (mail.phish-example.invalid [203.0.113.50])',
	'\tby mx.example.invalid with ESMTPS id abc123;',
	'\tMon, 20 Oct 2025 10:15:30 +0000',
	'Received: from internal.phish-example.invalid (unknown [2001:db8::1])',
	'\tby mail.phish-example.invalid with ESMTP;',
	'\tMon, 20 Oct 2025 10:15:20 +0000',
	'Authentication-Results: mx.example.invalid;',
	'\tspf=fail (sender IP is 203.0.113.50) smtp.mailfrom=phish-example.invalid;',
	'\tdkim=fail header.d=phish-example.invalid;',
	'\tdmarc=fail (p=none) header.from=example.invalid',
	'Authentication-Results: secondary.example.invalid; spf=pass smtp.mailfrom=example.invalid',
	'From: =?UTF-8?B?QmFuayBTZWN1cml0eQ==?= <security@example.invalid>',
	'Reply-To: "Help Desk" <help@phish-example.invalid>',
	'To: victim@example.invalid',
	'Message-ID: <sample-message-id-not-real@phish-example.invalid>',
	'Date: Mon, 20 Oct 2025 10:15:18 +0000',
	'Subject: Sample synthetic phishing headers',
	'MIME-Version: 1.0',
	'Content-Type: text/plain; charset=UTF-8',
	'',
	'This body is ignored by the analyzer.',
].join('\n');
